const messages = Object.freeze({
    DESC_LOGIN: 'Plataforma Online de Gestión de Recetas y Pedidos de estudios de salud',
    ERROR_LOGIN: 'El usuario y/o la contraseña son incorrectos',
    ERROR_RESTORE_PASSWORD: 'Los datos ingresados son incorrectos'
  });
  
  export default messages;